var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconJam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.82268 6.64283H5.67983C5.59458 6.64283 5.51282 6.60897 5.45254 6.54869C5.39226 6.48841 5.3584 6.40665 5.3584 6.3214V3.3214C5.3584 3.23615 5.39226 3.1544 5.45254 3.09412C5.51282 3.03384 5.59458 2.99997 5.67983 2.99997C5.76507 2.99997 5.84683 3.03384 5.90711 3.09412C5.96739 3.1544 6.00126 3.23615 6.00126 3.3214V5.99997H7.82268C7.90793 5.99997 7.98969 6.03384 8.04997 6.09412C8.11025 6.1544 8.14411 6.23615 8.14411 6.3214C8.14411 6.40665 8.11025 6.48841 8.04997 6.54869C7.98969 6.60897 7.90793 6.64283 7.82268 6.64283ZM6.00126 0.857117C3.16068 0.857117 0.858398 3.15983 0.858398 5.99997C0.858398 8.84012 3.16068 11.1428 6.00126 11.1428C8.8414 11.1428 11.1441 8.84012 11.1441 5.99997C11.1441 3.15983 8.8414 0.857117 6.00126 0.857117Z",
    fill: "#F43030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconJam);
export default __webpack_public_path__ + "static/media/iconJam.8154b08a8fafa09b23f6764dacde3559.svg";
export { ForwardRef as ReactComponent };